module.exports = __webpack_public_path__ + "static/media/gust.ee499962.svg";